var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"buttons":['cancel', 'save'],"large":"","title":"Telefone"},on:{"save":function($event){return _vm.$refs.Form.save()}}},[_c('Form',{ref:"Form",attrs:{"data":_vm.data},on:{"save":function($event){return _vm.$refs.Modal.hide()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }